export const dispatchesNotLoaded = {
    searchText: 'Buscar despacho',
    sort: true,
    disabled: false,
    partialField: '',
    columns: [
        {
            title: 'N° de viaje',
            name: 'idTrip',
            sort: true,
            type: 'string',
            editable: false,
            checkAll: false,
            class: 'left',
            value: (element: any) => element.idTrip
        },
        {
            title: 'N° de NV',
            name: 'saleNoteId',
            sort: true,
            type: 'string',
            editable: false,
            checkAll: false,
            class: 'left',
            value: (element: any) => element.saleNoteId
        },
        {
            title: 'N° de despacho',
            name: 'dispatchId',
            sort: true,
            type: 'string',
            editable: false,
            checkAll: false,
            class: 'left',
            value: (element: any) => element.dispatchId
        },
        {
            title: 'SKU',
            name: 'skuCode',
            sort: true,
            type: 'string',
            editable: false,
            checkAll: false,
            class: 'left',
            value: (element: any) => element.skuCode
        },
        {
            title: 'Lpn',
            name: 'lpn',
            sort: true,
            type: 'string',
            editable: false,
            checkAll: false,
            class: 'left',
            value: (element: any) => element.lpn
        },
        {
            title: 'Estado',
            name: 'state',
            sort: true,
            type: 'string',
            editable: false,
            checkAll: false,
            class: 'left',
            value: (element: any) => element.state
        }
    ]
};
